
import Vue from 'vue';
import Component from 'vue-class-component';
import Hero from '@/components/Hero.vue';
import NavBar from '@/components/NavBar/NavBar.vue';
import { authModule, impactBoardMembersModule } from '@/utils/store-acessor';
import { LocaleSelectorType } from '@/store/i18n.store.module';
import { i18nModule, i18nState } from '@/utils/store-acessor';
import { ImpactBoardMemberModel } from '@/models/impact-board-member.model';

@Component({
  components: {
    Hero,
    NavBar
  },
  metaInfo() {
    return {
      title: 'Ikone'
    };
  },
})
export default class TheLeagueProfile extends Vue {
  @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;
  @i18nModule.Getter('locale') selected!: LocaleSelectorType;
  @impactBoardMembersModule.Getter('memberById') memberById!: (
    id: number
  ) => ImpactBoardMemberModel;
  userInfo!: ImpactBoardMemberModel;

  get memberInfo(): ImpactBoardMemberModel {
    // console.log(
    //   'Aqui mesmo: ',
    //   this.memberById(parseInt(this.$route.params.id))
    // );
    return this.memberById(parseInt(this.$route.params.id));
  }

  toSocialMedia(url?: string) {
    if (url) {
      window.open(url, '_blank');
    }
  }

  backToTheLeague() {
    this.$router.back();
  }
}
